import script from "./SignInPageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./SignInPageHeader.vue?vue&type=script&setup=true&lang=js"

import "./SignInPageHeader.vue?vue&type=style&index=0&id=e88f6aa2&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/Store/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e88f6aa2"]])

export default __exports__